import { TimeInterval } from './time-interval';

export class ExceptionalOpeningHours {
  date: Date;
  openingHours: TimeInterval[];
  description?: string;
}
